import "./ServicesSolutions.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesSolutionsPage() {
  return <div>
      <Header />
      <OurServices />
      <Footer />
    </div>;
}